/**
 * 签到相关 API
 */

import { authenticatedFetch } from './auth';
import { appConfig } from '../config';

// 类型定义
export interface SignInResponse {
  code: number;
  msg: string;
  data: {
    point: number;        // 获得的积分
    signInDay: number;    // 连续签到天数
  } | null;
}

/**
 * 签到
 * @returns 签到结果
 */
export const createSignIn = async (): Promise<SignInResponse> => {
  const response = await authenticatedFetch(
    `${appConfig.api.baseUrl}/member/sign-in/record/create`,
    {
      method: 'POST',
    }
  );

  if (!response.ok) {
    throw new Error(`签到失败: ${response.status}`);
  }

  return response.json();
};
